import { Box, CircularProgress } from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import ReactGA from 'react-ga';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from "react-router-dom";
import '../../global.css';
import { getMyWatchlist } from "../../helpers/fetchWatchlist";
import { saveUser } from "../../redux/reducers/userSlice";
import authServices from "../../services/authServices";
import { loggout } from "../../utils/functions";
import LoginForm from "../auth/LoginForm";
import OTPForm from "../auth/OTPForm";
import SignupForm from "../auth/SignUpForm";
import ModalComponent from "./modalComponent";
import TermsConditions from "./terms_conditions";
import CookieStorage from '../../utils/cookieStorage';
import logsService from "../../services/logServices";
import InvestorActivityEventType from "../../utils/eventTypes";
export default function LoginModal({ open, organizationCode, handleClose = () => { }, openSign = false, setShowSignUp = () => { }, showTerms, setShowTerms = () => { } }) {
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    const referredBy = queryParams.get("referredBy")||sessionStorage.getItem("referredBy");

    const [otpForm, setOtpForm] = useState(false);
    const [signUp, setSignUp] = useState(false);
    const [number, setNumber] = useState("");
    const [inviteCode, setInviteCode] = useState("");
    const [otp, setOtp] = useState("");
    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const user = useSelector(state => state.user.data);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        if (openSign) {
            setSignUp(openSign);
        }
    }, [openSign]);
    
    const handleSendOtp = async (token) => {
        if (submitting) return;
        if (!token) {
            enqueueSnackbar("Please complete the CAPTCHA verification to proceed", { variant: "error" })
            return;
        }
        setSubmitting(true);
        try {
            ReactGA.event({
                category: "User Interaction",
                action: "Button Click",
                label: "Login Button"
            });
            const data = {
                mobileNumber: number,
                referralCode: signUp ? inviteCode : null,
                distributorCode: organizationCode,
                recaptchaValue: token
            };
            const res = await authServices.sendOTP(data);
            if (res && res.success) {
                setOtpForm(true);
                enqueueSnackbar("OTP sent successfully", { variant: "success" })
                logsService.addLog({
                    mobileNumber: number,
                    event: InvestorActivityEventType.LOGIN
                });
            }
            else {
                enqueueSnackbar(res.message, { variant: "error" })
            }
        } catch (error) {
            enqueueSnackbar(error?.message || "Something went wrong!", { variant: "error" })
        } finally {
            setSubmitting(false);
        }
    }

    const handleVerifyOtp = async () => {
        if (submitting) return;
        setSubmitting(true);
        try {
            const data = {
                mobileNumber: parseInt(number),
                otp: otp
            }
            const res = await authServices.verifyOTP(data);
            if (res && res.success && res?.data?.length > 0) {
                CookieStorage.set('access', res.token.access.token, { path: '/', days: 7 });
                CookieStorage.set('refresh', res.token.refresh.token, { path: '/', days: 15 });
                const userWithUrl = {
                    ...res.data[0],
                    url: res.url,
                };
                dispatch(saveUser(userWithUrl));
                logsService.addLog({
                    mobileNumber: number,
                    event: InvestorActivityEventType.VERIFY_LOGIN
                });
                await getMyWatchlist(dispatch)
                if (res.data[0].conditionAccepted) {
                    enqueueSnackbar("Logged in successfully", { variant: "success" })
                    navigate(`/dashboard?show=${(res.data[0]?.status === "FIRST_TIME" || res.data[0]?.status === "REGISTERED" || res.data[0]?.status === "KYC_APPROVED")}`, { state: res.data[0]?.status });
                }
                else {
                    setShowTerms(true);
                    onClose();
                }
            }
            else {
                enqueueSnackbar("OTP is incorrect", { variant: "error" })
            }
        } finally {
            setSubmitting(false);
        }
    }

    useEffect(() => {
        if (!otpForm) {
            setOtp("");
        }
    }, [otpForm])

    useEffect(() => {
        setNumber('')
        setInviteCode('')
        setOtp('')
    }, [signUp])

    const onClose = () => {
        setNumber("");
        // setOtp("");
        setOtpForm(false);
        handleClose();
        setTimeout(() => {
            setSignUp(false);
            setShowSignUp(false);
        }, 200)
    }

    const onCloseTerms = (value) => {
        setShowTerms(false);
        if (value) {
            enqueueSnackbar("Logged in successfully", { variant: "success" })
            navigate(`/dashboard?show=${(user?.status === "FIRST_TIME" || user?.status === "REGISTERED" || user?.status === "KYC_APPROVED")}`, { state: user?.status });
        }
        else {
            enqueueSnackbar("You cannot proceed without accepting buyer agreement.", { variant: "error" })

            loggout();
        }
    }

    return (
        <>
            {showTerms && <TermsConditions open={showTerms} handleClose={onCloseTerms} />}
            {loading && (
                <Box
                    sx={{
                        position: "absolute",
                        inset: 0,
                        zIndex: (theme) => theme.zIndex.modal + 1,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <CircularProgress
                        size={50}
                        thickness={3}
                    />
                </Box>
            )}
            <ModalComponent open={open} handleClose={onClose} title={otpForm ? "Enter OTP" : signUp ? "Signup" : "Login"}>
                {
                    !otpForm ?
                        signUp ?
                            <SignupForm inviteCode={inviteCode} setInviteCode={setInviteCode} setSignUp={setSignUp} number={number} setNumber={setNumber} handleSendOtp={handleSendOtp} submitting={submitting} />
                            :
                            <LoginForm setSignUp={setSignUp} number={number} setNumber={setNumber} handleSendOtp={handleSendOtp} setLoading={setLoading} setOtp={setOtp} setShowTerms={setShowTerms} onClose={onClose} distributorCode={referredBy} submitting={submitting} />
                        :
                        <OTPForm otp={otp} setOtp={setOtp} number={number} setOtpForm={setOtpForm} handleVerifyOtp={handleVerifyOtp} submitting={submitting} />
                }
            </ModalComponent>
        </>
    )
}

